<template>

    <div id="app" class="login">
        <b-navbar variant="faded" type="light" id="top-nav">
           <img  src="../assets/epg_migration_logo.png" alt="Carman &amp; Asscociates Logo" class="logo"/>
        </b-navbar>


            <b-container>
                <b-row class="justify-content-center mt-5">
                    <b-card header="Login" class="mx-3">
                        <b-alert variant="danger"
                                 @dismissed="alertDismissed"
                                 :show="has_error"  dismissible>
                            <font-awesome-icon icon="exclamation-circle" />   {{ error.message }}
                        </b-alert>

                        <b-form-group label="Email">
                            <b-form-input v-model="email"></b-form-input>
                        </b-form-group>

                        <b-form-group>

                            <div slot="label"> Password
                                <div class="float-right">
                                    <input type="checkbox" id="show_chars" v-model="show_chars"> <label
                                        for="show_chars">Show characters</label>
                                </div>
                            </div>

                            <b-form-input :type="password_field" v-model="password"></b-form-input>
                        </b-form-group>

                        <template slot="footer">
                            <b-button variant="primary" @click.prevent="login" class="float-right">
                                <span class="d-inline-block mr-2">Login</span> <font-awesome-icon icon="arrow-alt-circle-right"></font-awesome-icon>
                            </b-button>
                        </template>
                    </b-card>

                </b-row>
            </b-container>
        </div>




</template>

<script>
/* eslint-disable */
    import { bus } from '@/js/Bus'
    import _has from 'lodash/has'

    export default {
        name: 'Login',

        data : function(){

          return  {
              show_chars : false,
              email:null,
              password:null,
              error:{},
              id:null,
              password_field : 'password'
          }
        },

        computed : {
           has_error : function(){
               return _has(this.error,'message');
           },
        },

        watch : {
            show_chars : function(val){
                    if( val == true ){
                        this.password_field = 'text'
                    }else{
                        this.password_field = 'password'
                    }
            }
        },

        methods : {

            alertDismissed : function(){
                  this.error = {};
            },

            login : function(evt){

                evt.preventDefault();

                var vm = this;

                this.$http.post( this.app.version + '/front/login/' + this.id  ,{
                    email : this.email,
                    password : this.password,

                }).then(function(response){

                    vm.$auth.setToken(response.data.token.access_token,response.data.token.expires_in);

                    bus.$emit('authenticated');
                    
                    vm.$store.commit('updateFeeAgreement', response.data.feeAgreement)

                    /** SET local variables here */
                    localStorage.PORTAL_HASH = vm.id
                    localStorage.PORTAL_PROJECT = JSON.stringify(response.data.feeAgreement.project)
                    localStorage.PORTAL_CLIENT = JSON.stringify(response.data.feeAgreement.client)
                    
                    let routeLink = response.data.feeAgreement.hasEligibilities ? '/eligibility' : '/agreement'
                    vm.$router.push(routeLink);

                }).catch(function(error){
                    console.log(error)
                    vm.error = error.response.data;
                });
            }

        },

        mounted() {
            this.$auth.destroyToken();
            this.id = this.$route.params.id;
        }
    }
</script>

<style>
    legend {
        margin-bottom: 0px;
    }
</style>